import React, { useEffect } from 'react';
import apiService from '../../../services/api.service';
import { useHistory } from 'react-router';
import { useState } from 'react';
import '../../../util/extensions';
import XYChartTrends from './XYChartTrends';
import ComparePeriodLineChart from './ComparePeriodLineChart';

function Shipments(props) {
  const { FilterComponentData, baseQueryString, ShowTrendLine, ShowAvgLine } = props;
  const [trendsOverTimeReportData, setTrendsOverTimeReportData] = useState([]);
  const [mainAndCompareTrendData, setMainAndCompareTrendData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    let isCancelled = false;
    const LoadTrendReport = async (filterData) => {
      try {
        let result = await apiService.getShipmentsTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );
        if (!isCancelled) {
          setTrendsOverTimeReportData(result.data);
          setIsLoading(false);
        }
      } catch (err) {
        setIsLoading(false);
        console.log('error: ', err);
        if (err.response && err.response.status === 401) history.push('/login');
      }
    };

    const LoadCompareTrendReports = async (filterData) => {
      try {
        let mainReport = await apiService.getShipmentsTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.start,
          filterData.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        let compareReport = await apiService.getShipmentsTrendsReport(
          filterData.accountId,
          filterData.dateBasedOn,
          filterData.comparePeriodFilter.start,
          filterData.comparePeriodFilter.end,
          filterData.suppliers,
          filterData.groupBy,
          filterData.showSuppliersIndividually,
          filterData.originId,
          filterData.destinationId,
          filterData.carrierContractNumber
        );

        if (!isCancelled) {
          setIsLoading(false);
          setMainAndCompareTrendData({ main: mainReport.data, compare: compareReport.data });
        }
      } catch (err) {
        setIsLoading(false);
        console.log('error: ', err);
        if (err.response && err.response.status === 401) history.push('/login');
      }
    };

    if (FilterComponentData.accountId && (FilterComponentData.showAllSuppliers === true || FilterComponentData.suppliers.length > 0)) {
      setIsLoading(true);
      if (FilterComponentData.comparePeriodFilter.enabledCompare) {
        LoadCompareTrendReports(FilterComponentData);
      } else {
        LoadTrendReport(FilterComponentData);
      }
    } else {
      setIsLoading(false);
      setTrendsOverTimeReportData([]);
    }

    return () => {
      isCancelled = true;
    };
  }, [FilterComponentData, history]);

  function getDetailsPageUrl() {
    return '/shipments?' + baseQueryString;
  }

  return (
    <>
      {FilterComponentData && FilterComponentData.comparePeriodFilter && FilterComponentData.comparePeriodFilter.enabledCompare ? (
        <ComparePeriodLineChart
          Title="Shipments"
          ChartId="CompareShipmentChart"
          TrendsOverTimeReportDatas={mainAndCompareTrendData}
          GroupBy={FilterComponentData.groupBy}
          HiddenAllSuppliersSeriesOnInit={FilterComponentData.showSuppliersIndividually}
          IsLoading={isLoading}
          TitleLinkUrl={getDetailsPageUrl()}
        ></ComparePeriodLineChart>
      ) : (
        <XYChartTrends
          Title="Shipments"
          ChartId="ShipmentChart"
          TrendsOverTimeReportData={trendsOverTimeReportData}
          GroupBy={FilterComponentData.groupBy}
          HiddenAllSuppliersSeriesOnInit={FilterComponentData.showSuppliersIndividually}
          IsLoading={isLoading}
          TitleLinkUrl={getDetailsPageUrl()}
          ShowTrendLine={ShowTrendLine}
          ShowAvgLine={ShowAvgLine}
        ></XYChartTrends>
      )}
    </>
  );
}

export default Shipments;
